import { ShieldCheck } from "lucide-react";
import { TRUST_POINTS } from "@/lib/site";

export function TrustStrip() {
  return (
    <div className="border-y border-border bg-card/70">
      <div className="container-x py-5 flex flex-wrap items-center justify-center gap-x-8 gap-y-3 text-xs sm:text-sm uppercase tracking-wider text-silver">
        {TRUST_POINTS.map((p) => (
          <span key={p} className="inline-flex items-center gap-2">
            <ShieldCheck className="h-4 w-4 text-copper" /> {p}
          </span>
        ))}
      </div>
    </div>
  );
}
